import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { VirtualSiteGroupEntity } from "../../types/VirtualSiteGroupEntity";
import { VirtualSiteGroupDtoToEntity } from "../mappers/VirtualSiteGroupDtoToEntity";
import { VirtualSiteGroupEntityToDto } from "../mappers/VirtualSiteGroupEntityToDto";

const VirtualSiteGroupApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        VirtualSiteGroupLoad: builder.query<VirtualSiteGroupEntity, FormQuery>({
            providesTags: [ResourceName.VIRTUAL_SITE_GROUPS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VIRTUAL_SITE_GROUPS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return VirtualSiteGroupDtoToEntity(response);
            },
        }),
        VirtualSiteGroupSave: builder.mutation<VirtualSiteGroupEntity, FormMutation<VirtualSiteGroupEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VIRTUAL_SITE_GROUPS}`;
                const method = "POST";

                const body = VirtualSiteGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.VIRTUAL_SITE_GROUPS],
        }),
        VirtualSiteGroupUpdate: builder.mutation<VirtualSiteGroupEntity, FormMutation<VirtualSiteGroupEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VIRTUAL_SITE_GROUPS}/${mutation.data.id}`;
                const method = "PUT";

                const body = VirtualSiteGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.VIRTUAL_SITE_GROUPS],
        }),
    }),
});

export const { useVirtualSiteGroupLoadQuery, useVirtualSiteGroupSaveMutation, useVirtualSiteGroupUpdateMutation } = VirtualSiteGroupApi;
